export function convertToSlug(text: any) {
  return text
    .toString()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9\u0900-\u097F]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-+|-+$/g, '')
}
